<img
  [imgPreloader]="src"
  [attr.alt]="alt"
  [ngClass]="{ square: type === 'square', circle: type === 'circle' }"
  [ngStyle]="{ width: imgWidth, height: imgHeight }"
/>
